import { Modal } from '@/components/ModalRenderer/Modal';

const SekkiCreditPartner = () => (
  <Modal title="Sekki">
    <div className="flex flex-col gap-8">
      <div className="flex flex-col gap-4">
        <h3 className="text-section-util">1. Kreditgivarens/kreditförmedlarens namn och kontaktuppgifter</h3>
        <div className="flex flex-col gap-2">
          <p>
            <strong className="text-body-semibold">Kreditgivare</strong>
          </p>
          <p>Fairlo AB (nedan &quot;Kreditgivaren&quot; eller &quot;Fairlo&quot;) (org.nr 559084-1101)</p>
          <p>
            <strong className="text-body-semibold">Adress</strong>
          </p>
          <p>Linnégatan 76, 115 23 Stockholm</p>
          <p>
            <strong className="text-body-semibold">E-post</strong>
          </p>
          <p>
            <a className="link" href="mailto:kundservice@fairlo.se">
              kundservice@fairlo.se
            </a>
          </p>
          <p>
            <strong className="text-body-semibold">Webbadress</strong>
          </p>
          <p>
            <a className="link" href="https://www.fairlo.se" target="_blank" rel="noopener noreferrer">
              www.fairlo.se
            </a>
          </p>
        </div>
      </div>

      <div className="flex flex-col gap-4">
        <h3 className="text-section-util">2. Beskrivning av huvuddragen i kreditprodukten</h3>
        <div className="flex flex-col gap-2">
          <p>
            <strong className="text-body-semibold">Typ av kredit</strong>
          </p>
          <p>Kontokredit utan säkerhet för betalning av fakturor och andra betalningsförpliktelser.</p>
          <p>
            <strong className="text-body-semibold">Det sammanlagda kreditbeloppet</strong>
          </p>
          <p className="text-caption-regular">
            Detta är den övre kreditgräns eller det totala belopp som ställs till förfogande genom
            kreditavtalet.
          </p>
          <p>Det sammanlagda kreditbeloppet framgår av Kreditavtalet.</p>
          <p>
            <strong className="text-body-semibold">Villkoren för kreditutnyttjandet</strong>
          </p>
          <p className="text-caption-regular">Här anges när och hur pengarna kan lyftas.</p>
          <p>
            Krediten får användas för betalning av fakturor och andra betalningsförpliktelser som godkänns av
            Kreditgivaren inom ramen för beviljat Kreditutrymme. Återbetalningar medför inte att återbetalt
            Kreditutrymme automatiskt blir tillgängligt för nytt utnyttjande. Kreditbeloppet görs inte
            tillgängligt för kontantuttag eller fria uttag och kan inte användas för andra ändamål än vad som
            framgår av Kreditavtalet.
          </p>
          <p>
            <strong className="text-body-semibold">Kreditavtalets löptid</strong>
          </p>
          <p>
            Återbetalningstiden för utnyttjad Kredit framgår av den vid var tid gällande Betalningsplanen.
          </p>
          <p>
            <strong className="text-body-semibold">
              Avbetalningar och, i förekommande fall, i vilken ordning dessa ska fördelas
            </strong>
          </p>
          <p>
            Kredittagaren återbetalar Krediten genom månatliga betalningar enligt den vid var tid gällande
            Betalningsplanen. Betalning sker via autogiro den 25:e varje månad. Varje betalning avräknas först
            mot eventuella avgifter och ränta och därefter mot kapitalbeloppet.
          </p>
          <p>
            <strong className="text-body-semibold">Det totala belopp som du ska betala</strong>
          </p>
          <p className="text-caption-regular">
            Detta är det lånade kapitalet plus ränta och eventuella kostnader i samband med krediten.
          </p>
          <p>
            Det totala beloppet att återbetala beräknas på den kredit som beviljats och utbetalats, räntenivå,
            samt vald betalningsplan. Ett representativt exempel finns i avsnitt 3
          </p>
          <p>
            <strong className="text-body-semibold">
              I tillämpliga fall:
              <br /> Krediten beviljas i form av betalningsanstånd för en vara eller en tjänst eller är
              kopplad till leveranser av specifika varor eller tillhandahållande av en tjänst
              <br />
              Varans/tjänstens namn
              <br />
              Kontantpris
            </strong>
          </p>
          <p>Ej tillämpbart.</p>
          <p>
            <strong className="text-body-semibold">
              I tillämpliga fall: <br />
              Begärda säkerheter
              <br /> Detta är en beskrivning av den säkerhet som ska ställas i samband med kreditavtalet.
            </strong>
          </p>
          <p>Krediten löper utan säkerhet.</p>
          <p>
            <strong className="text-body-semibold">
              I tillämpliga fall:
              <br /> Avbetalningarna medför inte omedelbar amortering av kapitalet
            </strong>
          </p>
          <p>
            Vid betalning av Krediten sker avräkning först mot förfallna avgifter, kostnader och räntor,
            därefter utestående kapitalskuld.
          </p>
        </div>
      </div>

      <div className="flex flex-col gap-4">
        <h3 className="text-section-util">3. Kreditkostnader</h3>
        <div className="flex flex-col gap-2">
          <p>
            <strong className="text-body-semibold">
              Kreditränta eller i tillämpliga fall de olika krediträntor som gäller för kreditavtalet
            </strong>
          </p>
          <p>
            Den nominella årsräntan är 19,90 %.
            <br /> Räntan är rörlig, vilket innebär att Kreditgivaren har rätt att omedelbart ändra
            räntesatsen i den utsträckning som det motiveras av kreditpolitiska beslut, ökade
            upplåningskostnader för Kreditgivaren eller andra kostnadsändringar som Kreditgivaren inte
            skäligen kunde förutse när avtalet ingicks. Kreditgivaren underrättar Kredittagaren om en
            ränteändring innan den börjar gälla samt hur Kredittagarens totala skuld och Månadsbelopp påverkas
            av ränteändringen.
          </p>
          <p>
            <strong className="text-body-semibold">
              Effektiv ränta
              <br />
              Detta är totalkostnaden uttryckt som den effektiva räntan av det samlade kreditbeloppet.
              <br /> Den effektiva räntan anges för att hjälpa olika erbjudanden.
            </strong>
          </p>
          <p>
            Räkneexempel vid låneutrymme på 18 500 kr och en nominell rörlig ränta på 19,90 %. Med ett
            lånebelopp på 18 500 kr betalar du då ett månadsbelopp om 493 kr som betalas en gång i månaden
            under 60 månader. Den effektiva räntan blir 21,82 % och totalt att återbetala blir 29 580 kr.
          </p>
          <p>
            <strong className="text-body-semibold">
              Är det, för att erhålla krediten eller för att erhålla den enligt villkoren i marknadsföringen,
              obligatoriskt att ingå avtal om
              <br />— en försäkring som säkrar krediten?
            </strong>
          </p>
          <p>Nej.</p>
          <p>
            <strong className="text-body-semibold">— någon annan kompletterande tjänst?</strong>
          </p>
          <p>Nej.</p>
          <p>
            <strong className="text-body-semibold">
              <br />
              Om kostnaderna för dessa tjänster inte är kända av kreditgivaren ska de inte inkluderas i den
              effektiva räntan.
            </strong>
          </p>
          <br />
          <br />
          <h4 className="text-section-util">Härtill hörande kostnader</h4>
          <p>
            <strong className="text-body-semibold">
              I tillämpliga fall:
              <br /> Det krävs att man behålla ett eller flera konton för att registrera både
              betalningstransaktioner och kreditutnyttjanden
            </strong>
          </p>
          <p>Ej tillämpbart.</p>
          <p>
            <strong className="text-body-semibold">
              I tillämpliga fall:
              <br /> Kostnad för att använda ett särskilt betalningsmedel (t.ex. ett kreditkort)
            </strong>
          </p>
          <p>Ej tillämpbart.</p>
          <p>
            <strong className="text-body-semibold">
              I tillämpliga fall:
              <br /> Andra kostnader i samband med kreditavtalet
            </strong>
          </p>
          <p>
            Om Kredittagaren återkallar sitt autogiromedgivande tillkommer en kostnad om 249 kronor per månad
            fram till dess att Krediten är betald i sin helhet.
          </p>
          <p>
            <strong className="text-body-semibold">
              I tillämpliga fall:
              <br /> Villkor för att ändra kostnaderna i samband med kreditavtalet
            </strong>
          </p>
          <p>
            Kreditgivaren äger när som helst under kredittiden rätt att besluta om höjning av särskild avgift
            i den mån Kreditgivarens kostnader ökat för den åtgärd avgiften avser att täcka. Kreditgivaren
            tillämpar ovanstående villkor om ändring av avgift även till kredittagarens förmån och sänker
            således avgiften i den mån Kreditgivarens kostnader för den åtgärd avgiften avser att täcka
            minskat.
          </p>
          <p>
            <strong className="text-body-semibold">
              I tillämpliga fall:
              <br /> Skyldighet att betala notariatsavgifter
            </strong>
          </p>
          <p>Ej tillämpbart.</p>
          <p>
            <strong className="text-body-semibold">Kostnader i samband med försenade betalningar</strong>
          </p>
          <p className="text-caption-regular">
            Uteblivna betalningar kan få allvarliga konsekvenser (t.ex. tvångsförsäljning) och försvåra
            möjligheterna till att erhålla kredit.
          </p>
          <p>
            Kredittagaren debiteras dröjsmålsränta på det totala förfallna månadsbeloppet inklusive den del
            som utgör ränta från förfallodagen till dess att Kreditgivaren erhåller full betalning.
            Kreditgivaren har även rätt att påföra en påminnelseavgift samt lagstadgade inkassokostnader.
          </p>
          <p>• Påminnelsekostnad: 60 kr</p>
          <p>• Inkassokostnad: 180 kr</p>
          <p>• Dröjsmålsränta: 20 % nominell årsränta över referensräntan</p>
          <p>
            Om Krediten överlämnas till Kronofogdemyndigheten tillkommer ytterligare lagstadgade kostnader för
            uteblivna betalningar.
          </p>
        </div>
      </div>

      <div className="flex flex-col gap-4">
        <h3 className="text-section-util">4. Andra viktiga rättsliga aspekter</h3>
        <div className="flex flex-col gap-2">
          <p>
            <strong className="text-body-semibold">Ångerrätt</strong>
          </p>
          <p className="text-caption-regular">
            Ni har rätt att frånträda kreditavtalet inom 14 kalenderdagar.
          </p>
          <p>Ja.</p>
          <p>
            <strong className="text-body-semibold">Förtidsåterbetalning</strong>
          </p>
          <p className="text-caption-regular">
            Hela eller delar av krediten kan återbetalas i förtid när som helst.
          </p>
          <p>Kredittagaren kan när som helst återbetala hela eller delar av krediten.</p>
          <p>
            <strong className="text-body-semibold">
              I tillämpliga fall:
              <br /> Kreditgivaren har rätt till kompensation vid förtidsåterbetalning
            </strong>
          </p>
          <p>Nej.</p>
          <p>
            <strong className="text-body-semibold">Sökning i en databas</strong>
          </p>
          <p className="text-caption-regular">
            Om en kreditansökan avvisas på grundval av en sökning i en databas måste kreditgivaren genast och
            kostnadsfritt meddela dig resultatet av sökningen. Detta gäller inte om utlämnandet av sådan
            information är förbjudet enligt gemenskapslagstiftningen eller strider mot allmän ordning och
            säkerhet.
          </p>
          <p>
            Kredittagaren har rätt att kostnadsfritt få information när en kreditansökan avvisas på grundval
            av en sökning i en databas.
          </p>
          <p>
            <strong className="text-body-semibold">Rätt att få ett utkast till ett kreditavtal</strong>
          </p>
          <p className="text-caption-regular">
            Du har rätt att på begäran kostnadsfritt få en kopia av ett utkast till ett kreditavtal. Denna
            bestämmelse är inte tillämplig om kreditgivaren vid tidpunkten för begäran är ovillig att ingå
            kreditavtalet med dig.
          </p>
          <p>
            Ja, vid ansökningstillfället presenterar Kreditgivaren ett Kreditavtal som Kredittagaren måste
            godkänna. Enbart om Kredittagaren signerar avtalet kan kredit beviljas. Krediterbjudandet måste
            accepteras i nära tidsmässigt samband med att ansökan om kredit fylls i. När ansökningsprocessen
            avbrutits är utkastet inte längre giltigt, varför sökande part måste ansöka på nytt och få ett
            förnyat utkast.
          </p>
          <p>
            <strong className="text-body-semibold">
              I tillämpliga fall:
              <br /> Den tid kreditgivaren är bunden av skyldigheterna som uppkommit innan avtalet ingåtts
            </strong>
          </p>
          <p>Ej tillämpbart.</p>
        </div>
      </div>

      <div className="flex flex-col gap-4">
        <h3 className="text-section-util">
          5. Ytterligare information när det gäller distansförsäljning av finansiella tjänster
        </h3>
        <div className="flex flex-col gap-2">
          <h4 className="text-body-semibold">a) Beträffande kreditgivaren</h4>
          <h5 className="text-body-semibold">
            I tillämpliga fall:
            <br /> Kreditgivarens företrädare i den medlemsstat där du är bosatt
          </h5>
          <p>Ej tillämpligt.</p>
          <h5 className="text-body-semibold">
            I tillämpliga fall:
            <br /> Registrering
          </h5>
          <p>Kreditgivaren är registrerad hos Bolagsverket med organisationsnummer 559084-1101.</p>
          <h5 className="text-body-semibold">
            I tillämpliga fall:
            <br /> Den berörda tillsynsmyndigheten
          </h5>
          <p>Finansinspektionen</p>
          <h4 className="text-body-semibold">b) Beträffande kreditavtalet</h4>
          <h5 className="text-body-semibold">
            I tillämpliga fall:
            <br /> Utnyttjande av ångerrätten
          </h5>
          <p>
            Kredittagare som vill åberopa sin ångerrätt kan göra detta i inloggat läge på Mina sidor på{' '}
            <a className="link" href="https://www.fairlo.se" target="_blank" rel="noopener noreferrer">
              www.fairlo.se
            </a>{' '}
            och följa instruktionerna. Kredittagaren har då 30 dagar på sig att återbetala eventuell utnyttjad
            kredit samt upplupna räntor, räknat från och med den dagen då Kredittagaren fick tillgång till
            kreditbeloppet till och med den dag då krediten återbetalas.
          </p>
          <h5 className="text-body-semibold">
            I tillämpliga fall:
            <br /> Den lagstiftning som kreditgivaren använt som grundval för att upprätta förbindelser med
            dig innan kreditavtalet ingicks
          </h5>
          <p>
            Kreditgivaren tillämpar vid var tid gällande lagstiftning för konsumentkrediter, innefattande
            lagstiftning, allmänna råd, rekommendationer och föreskrifter.
          </p>
          <h5 className="text-body-semibold">
            I tillämpliga fall:
            <br /> Klausul om tillämplig lagstiftning för kreditavtalet och/eller behörig domstol
          </h5>
          <p>
            Svensk rätt tillämpas och svenska domstolar är behöriga att pröva eventuella tvister om krediten.
            Kreditgivaren äger dock rätt att väcka talan i annan jurisdiktion än Sverige, i den mån det krävs
            för att tillvarata Kreditgivarens rättigheter enligt kreditavtalet.
          </p>
          <h5 className="text-body-semibold">
            I tillämpliga fall:
            <br /> Språkordning
          </h5>
          <p>Information och avtalsvillkor lämnas på svenska. Kommunikation sker på svenska.</p>
          <h4 className="text-body-semibold">c) Beträffande prövning</h4>
          <h5 className="text-caption-semibold">
            Förekomst av och tillgång till en mekanism för klagomål och prövning utanför domstol
          </h5>
          <p>
            Om Kredittagaren är missnöjd bör denne i första hand kontakta Kreditgivarens kundservice på{' '}
            <a className="link" href="https://www.fairlo.se" target="_blank" rel="noopener noreferrer">
              www.fairlo.se
            </a>
            .
          </p>
          <p>
            Om Kredittagaren efter att ha kontaktat kundservice fortfarande inte är nöjd kan Kredittagaren
            upprätta ett skriftligt kundklagomål till Kreditgivarens Kundombudsman via e-post på{' '}
            <a className="link" href="mailto:kundombud@fairlo.se">
              kundombud@fairlo.se
            </a>
            . En blankett för detta finns på Kreditgivarens hemsida{' '}
            <a className="link" href="https://www.fairlo.se" target="_blank" rel="noopener noreferrer">
              www.fairlo.se
            </a>
            . Kreditgivaren hanterar klagomålen i enlighet med Finansinspektionens allmänna råd om
            klagomålshantering avseende finansiella tjänster till konsumenter.
          </p>
          <p>
            Kreditgivaren vill upplysa om att Kredittagaren kan få hjälp och kostnadsfri vägledning från
            Konsumenternas Bank- och finansbyrå och Konsumenternas Försäkringsbyrå samt den kommunala
            konsumentvägledningen.
          </p>
          <p>
            Om Kredittagaren är missnöjd med Kreditgivarens beslut i ett enskilt ärende kan Kredittagaren få
            saken prövad av Allmänna reklamationsnämnden med postadress Box 174, 101 23 Stockholm, telefon
            08-508 860 00. Mer information om Allmänna reklamationsnämnden går att finna på dess hemsida{' '}
            <a className="link" href="https://www.arn.se" target="_blank" rel="noopener noreferrer">
              www.arn.se
            </a>
            .
          </p>
        </div>
      </div>
    </div>
  </Modal>
);

export default SekkiCreditPartner;
